// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"FT-z","trustedRetailerTooltipWrapper":"GT-z"};